<script>
import baseList from "@/views/components/base/baseList.vue";
let customerId = window.localStorage.getItem("customerId");

export default {
  extends: baseList,
  data() {
    return {
      table: {
        mname: "approvalProcess",
        key: "id",
        url: {
          list: "/admin/system/flowPath/list",
        },
        output: false,
      },
      actions: [
        {
          label: "新增流程",
          icon: "md-add",
          type: "info",
          onClick: this.toAdd,
          auth: "",
        },
      ],
      menus: [
        // {
        //   label: "资产类型",
        //   name: "deviceClass_list",
        //   auth: "",
        // },
        // {
        //   label: "型号库",
        //   name: "deviceType_list",
        //   auth: "",
        // },
        // {
        //   label: "物资分类",
        //   name: "consumablesClass_list",
        //   auth: "",
        //   show: (Number(customerId) === 0),
        // },
        {
          label: "领用流程",
          name: "approvalProcess_list",
          auth: "",
        },
        {
          label: "采购流程",
          name: "ProcessIndex",
          show: !(Number(customerId) === 0),
          auth: "",
        },
      ],
      // menus: [
      //   {
      //     label: "常用语",
      //     name: "commondescr_list_main",
      //     auth: "system/commondescr/index",
      //   },
      //   {
      //     label: "服务字典",
      //     name: "serveKnowledgeBase",
      //     auth: "system/commondescr/index",
      //   },
      //   {
      //     label: "知识库",
      //     name: "issueKnowledgeBase",
      //     auth: "system/commondescr/index",
      //   },
      //   {
      //     label: "知识库审核",
      //     name: "auditKnowledgeBase",
      //     auth: "system/commondescr/index",
      //   },
      //   {
      //     label: "工单类型",
      //     name: "worktype_list",
      //     auth: "system/worktype/index",
      //   },
      //   // {
      //   //   label: "供应商",
      //   //   name: "supplier_main",
      //   //   auth: "system/supplier/index",
      //   // },
      //   {
      //     label: "资产类型",
      //     name: "deviceClass_list",
      //     auth: "system/deviceClass/index",
      //   },
      //   {
      //     label: "型号库",
      //     name: "deviceType_list",
      //     auth: "",
      //   },
      //   {
      //     label: "耗材分类",
      //     name: "consumablesClass_list",
      //     auth: "system/consumablesClass/index",
      //     show: !(Number(customerId) === 0),
      //   },
      //   // {
      //   //     label: "知识库标签",
      //   //     name: "knowledgeBaseTag_list",
      //   //     auth: "system/knowledgeBaseTag/index",
      //   // },
      //   {
      //     label: "楼宇管理",
      //     name: "offices_building_list",
      //     auth: "system/offices/index",
      //   },
      //   // {
      //   //     label: "巡检模板",
      //   //     name: "templateManagement_list",
      //   //     auth: "system/templateManagement/index",
      //   // },
      //   {
      //     label: "巡检类别",
      //     name: "category_list",
      //     auth: "system/category/index",
      //   },
      //   {
      //     label: "巡检项",
      //     name: "scene_list",
      //     auth: "system/scene/index",
      //   },
      //   {
      //     label: "坐席列表",
      //     name: "callConfig_list",
      //     auth: "/admin/callConfig/lists",
      //   },

      //   {
      //     label: "投诉管理",
      //     name: "feedback_list",
      //     auth: "/admin/feedback/lists",
      //   },
      //   {
      //     label: "流程管理",
      //     name: "approvalProcess_list",
      //     auth: "",
      //   },
      // ],
      filters: [],
      tableCols: [
        {
          type: "index",
          title: "序号",
          width: 80,
          align: "center",
        },
        {
          title: "流程",
          minWidth: 180,
          align: "left",
          // key: 'classesDate'
          render: (p, params) => {
            let row = params;
            console.log(params);
            return <span>{row.row.workType == 2 ? "物资领用流程" : ""}</span>;
          },
        },
        {
          title: "操作",
          align: "center",
          key: "handle",
          width: 100,
          handle: [
            (vm, h, currentRow, param) => {
              return (
                <Button
                  size="small"
                  onClick={() => this.toEdit(currentRow)}
                  type="default"
                  style={{
                    border: "none",
                    color: "#4991ff",
                  }}
                >
                  编辑
                </Button>
              );
            },
          ],
        },
      ],
      examineId: "",
      receiveWorkState: 1,
      workType: "",
      examineList: [],
      id: "",
    };
  },
  created() {},
  methods: {
    toAdd(type) {
      if (type != 1) {
        this.workType = "";
        this.examineId = "";
        this.receiveWorkState = 1;
      }
      // console.log(type);
      this.getExamineList();
      this.$Modal.success({
        closable: true,
        title: "编辑流程",
        width: "800px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <div>
              <div style="width:100%; margin:20px 0 0 0">
                <div style="margin-bottom:20px;">
                  是否开启审核：
                  <el-radio vModel={this.receiveWorkState} label={1}>
                    是
                  </el-radio>
                  <el-radio vModel={this.receiveWorkState} label={2}>
                    否
                  </el-radio>
                </div>
                {this.receiveWorkState == 1 ? (
                  <div>
                    <div style="margin-bottom:20px;display:flex;align-items: center;">
                      <div style="width:100px">审核人：</div>
                      <Select
                        vModel={this.examineId}
                        clearable={true}
                        style="width:200px"
                        placeholder="请选择审核人"
                      >
                        {this.examineList.map((item) => {
                          return (
                            <Option value={item.id} key={item.id}>
                              {item.nickName}
                            </Option>
                          );
                        })}
                      </Select>
                    </div>
                  </div>
                ) : (
                  ""
                )}
                <div style="margin-bottom:20px;display:flex;align-items: center;">
                  <div style="width:100px">流程：</div>
                  <Select
                    vModel={this.workType}
                    clearable={true}
                    style="width:200px"
                    placeholder="请选择流程"
                  >
                    <Option value={2} key={2}>
                      物资领用流程
                    </Option>
                  </Select>
                </div>
                <div style="display:flex; justify-content: center; margin:40px 0;">
                  <Button
                    type="primary"
                    style={{ margin: "0 20px 0 0" }}
                    onClick={() => this.onEdit(type)}
                  >
                    确认
                  </Button>
                  <Button
                    type="primary"
                    onClick={() => {
                      this.$Modal.remove();
                    }}
                  >
                    取消
                  </Button>
                </div>
              </div>
            </div>
          );
        },
      });
    },
    toEdit(item) {
      this.workType = item.workType;
      this.receiveWorkState = item.receiveWorkState;
      this.examineId = item.examineId;
      this.id = item.id;
      this.toAdd(1);
    },
    async onEdit(type) {
      // console.log(type);
      let d = {
        receiveWorkState: this.receiveWorkState,
      };
      if (type == 1) {
        d.id = this.id;
      }
      if (this.receiveWorkState == 1) {
        if (!this.examineId) {
          $utils.toast.success("请选择审核人！");
          return;
        }
        d.examineId = this.examineId;
      }
      if (this.workType != 2) {
        $utils.toast.success("请选择流程！");
        return;
      }
      d.workType = this.workType;
      // console.log(d);
      let res = await $utils.api.load(
        "/admin/system/flowPath",
        d,
        type == 1 ? "PUT" : "POST"
      );
      if (res.code == 200) {
        this.search();
        this.receiveWorkState = 1;
        this.examineId = "";
        this.workType = "";
        this.$Modal.remove();
      }
    },
    async getExamineList() {
      let d = {};
      let res = await $utils.api.load(
        "/admin/system/maiUser/selectList",
        d,
        "get"
      );
      console.log(res);
      if (res.code == 200) {
        this.examineList = res.rows;
      }
    },
  },
};
</script>

<style></style>
